import React from 'react'
import {Container} from 'react-bootstrap'
import Tombol from 'components/componentsmall/button'
import Judul from 'components/componentsmall/title'
import './style.css'

export default function span_main() {
    return (
            <Container className="content-spam">
                <Judul judul="Menjadi Reseller sekarang juga" />
                <p>Kata-kata menarik lagi, buat calon user, agar yang ragu-ragu daftar segera klik link <span>di bawah.</span>  setelah disuguhkan benefit-benefit mengenai aplikasinya.</p>
                <Tombol to="/daftar" tombol="Daftar Sekarang" />
             </Container>
    )
}
